<template>
  <el-dialog :show-close=false :visible.sync="centerDialogVisible" width="400px" top="25vh" center :close-on-click-modal=false :close-on-press-escape=false>
    <div class="teach-assistant">
      <div class="content">
        <p>未找到所在学校？请联系助教</p>
        <div class="copy-qq">
          助教QQ号：<br>{{qq}}
          <a v-clipboard:copy="qq" v-clipboard:success="onCopy">复制</a>
        </div>
        <div class="wechat">助教微信号：<br>abc_jinshanshan</div>
      </div>
      <div class="qrcode">
        <img src="../../assets/wechat_qrcode.png" alt>
      </div>
    </div>
    <div class="close-btn">
      <span @click="closeDialog">知道了</span>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'Help',
  data () {
    return {
      centerDialogVisible: false,
      qq: '2868967082'
    }
  },
  methods: {
    showDialog () {
      this.centerDialogVisible = true
    },
    closeDialog () {
      this.centerDialogVisible = false
    },
    onCopy () {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    }
  }
}
</script>
<style scoped>
.teach-assistant {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 170px;
  font-size: 12px;
  color: #333;
}
.content {
  width: 250px;
  padding: 20px 0 0 30px;
  box-sizing: border-box;
}
.copy-qq {
  margin-top: 20px;
}
.copy-qq a {
  margin-left: 20px;
  color: #FE793A;
  cursor: pointer;
}
.wechat {
  margin-top: 20px;
}
.qrcode {
  width: 150px;
  margin-top: 10px;
}
.qrcode img {
  width: 120px;
}
.close-btn {
  text-align: right;
  padding-right: 20px;
  font-size: 12px;
  color: #FE793A;
}

.close-btn span {
  cursor: pointer;
}
</style>
